import axios from 'axios';
export const saveUserAddress = (locationInfo) => {
	return axios
		.post(`${process.env.NEXT_PUBLIC_SERVER_API}/api/auth/saveAddress`, {
			locationInfo,
		})
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error;
		});
};
